module.exports = __webpack_public_path__ + "img/134-liechtenstein.558fdd1f.svg";